export function addFootnoteAndAdjustSpacing(footnote) {
    const footnoteExists = document.getElementById('footNote');
    if (footnoteExists) footnoteExists.remove();

    if (footnote.length > 0) {
        let tradingData = document.getElementById('tradingData');
        let footnoteDiv = document.createElement('div');
        footnoteDiv.className = 'text-xxs text-secondary mt-4 mb-6';
        footnoteDiv.style.display = 'block';
        footnoteDiv.style.clear = 'both';
        footnoteDiv.innerHTML = footnote;
        footnoteDiv.setAttribute('id', 'footNote');
        tradingData.appendChild(footnoteDiv);
    }
}

export function addFootnoteToPortfolioGraph(footnote) {
    const footnoteExists = document.getElementById('portfolioFootNote');
    if (footnoteExists) footnoteExists.remove();

    if (footnote && footnote.length > 0) {
        let portfolioData = document.getElementById('portfolioData');
        if (portfolioData) {
            let footnoteDiv = document.createElement('div');
            footnoteDiv.className = 'text-xxs text-secondary mt-4 mb-6';
            footnoteDiv.style.display = 'block';
            footnoteDiv.style.clear = 'both';
            footnoteDiv.innerHTML = footnote;
            footnoteDiv.setAttribute('id', 'portfolioFootNote');
            portfolioData.appendChild(footnoteDiv);
        }
    }
}